/* eslint-disable import/prefer-default-export */

import type {
  Guardrail,
  Folder as FolderApiModel
} from '@src/endpoints/openapis/saas-cam-guardrails'

export interface Category {
  original?: FolderApiModel
  id?: string
  name?: string
  totalCount?: number
  enabledCount?: number
}

export interface GuardrailCategory {
  label: string
  value: string
}

export interface Folders {
  [key: string]: Category
}
export interface GuardrailCategories extends Folders {}

export interface GuardrailFolder {
  value: string
  label: string
}

export enum SeverityEnum {
  NONE = 'NONE',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW'
}

export interface GuardrailEditModel {
  original?: Guardrail
  name?: string
  severity?: SeverityEnum
  query?: string
  id?: string
  description?: string
  suppressionDeleteObject?: boolean
  suppressionCreateObject?: boolean
  suppressionDeleteIdentity?: boolean
  suppressionCreateIdentity?: boolean
  label?: string
  categories?: string[]
  remediation?: string
  audit?: string
}
